import React, { useEffect, useState } from 'react'
import { ButtonList, PEN_ADD, Button } from '../..'
import { ButtonTypes } from '../../../Definitions'
import { colors, glyphs } from '../../../Styles'
import { useTranslation } from 'react-i18next'

import { getSectionById } from '../../../Assets/TestData/sectionsData'

interface SectionAdd_Props {
  sectionId: number
  onPenClick?: (penId: number) => void
  onCancelBtn?: () => void
}
/**
 * SECTION_ADD
 * @param sectionId Unique identifier for each section.
 * @param onPenClick OnClick event to handle penId.
 * @param onCancelBtn OnClick event to handle Cancel btn.
 * @returns a section of pens for Freeda Location Feeder systems.
 */
export default function SECTION_ADD({ sectionId, onPenClick, onCancelBtn }: SectionAdd_Props) {
  const {t} = useTranslation()
  const section = getSectionById(sectionId);
  const [selectedPenNo, setSelectedPenNo] = useState<number | null>(null);

  function CancelBtnClick() {
    if (onCancelBtn) onCancelBtn()
  }

  // Handle Pen click
  const handlePenClick = (penId: number) => {
    if (onPenClick) {
      onPenClick(penId);
      setSelectedPenNo(penId)
    }
  };

  useEffect(() => {
  console.log('Selected Pen No updated:', selectedPenNo);
}, [selectedPenNo]);

  // Error throwback if no section number excists
  if (!section) {
    return <div>Section {sectionId} not found</div>;
  }

  const AddModeBtns = 
  <ButtonList 
    contents={[t("buttons.cancelBtn"), t("buttons.add"), t("buttons.move"), t("buttons.edit")]}
    onClick={(i => {
      if (i === 0) {CancelBtnClick()}
    })}
    buttonType={ButtonTypes.tableButton}
    startEnhancers={[
      glyphs.Close({fillColor: colors.greyDarkPrimary}),
      glyphs.Add({fillColor: colors.greyDarkPrimary}), 
      glyphs.AnimalMove({fillColor: colors.greyDarkPrimary}), 
      glyphs.Edit({fillColor: colors.greyDarkPrimary})
    ]}
    disabled={[false, true, true, true]}
    overrides={(index) => ({
      baseButton: {
        backgroundColor: index === 1 ? colors.greyLightSecondary : colors.greyLightPrimary
      },
      hoverStyles: {
        backgroundColor: colors.greyLightSecondary
      },
      disabledStyles: {
        opacity: index === 1 ? 1 : 0.5
      },
      contentStyles: {
        color: colors.greyDarkPrimary
      }
    })}
  />

  const renderContent = () => {
    return section.pens.map(pen => (
      <PEN_ADD
        key={pen.animal?.animalId}
        penId={pen.penId}
        hasHoverEffekt={true}
        // onClick={() => handlePenClick(pen?.penId as number)}
      />
    ));
  }

  return (
      <div style={{ width: "fit-content", height: "fit-content" }}>
        <div style={{ display: "flex", flexDirection: "row", justifyContent: "end", alignItems: "end", padding: "0px 20px" }}>
          {AddModeBtns}
        </div>
        <div style={{ display: "grid", gridTemplateColumns: "", width: "fit-content", gap: "10px", borderRadius: "10px", overflow: "hidden" }}>
          {renderContent()}
        </div>
      </div>
  );
}